import { fetcher } from "helpers/fetcher";

import { TGetTicketNotesListReq, TGetTicketNotesListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTicketNotesList = async (payload: TGetTicketNotesListReq) => {
  return await fetcher<TGetTicketNotesListRes, TGetTicketNotesListReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_TICKET_NOTES_LIST,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_TICKET_NOTES_LIST.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetTicketNotesList = async (
  payload: TGetTicketNotesListReq
) => {
  return (await getTicketNotesList(payload)).data;
};

queryGetTicketNotesList._key = (payload: TGetTicketNotesListReq) => [
  ENDPOINT.MANAGEMENT.GET_TICKET_NOTES_LIST.url,
  payload,
];
